import "./RideItem.scss"
import moment from "moment"
import { ListItem, ListItemText, Typography, Button } from "@mui/material"
import A2A from "../../../assets/icons/A2A"
import A2B from "../../../assets/icons/A2B"
import { useTranslation } from "react-i18next"

import { useAppDispatch } from "../../../redux/hooks"
import { cancelReservationAsync } from "../../../redux/slices/reservationsSlice"

export const RideItem = ({ ride }: any) => {
  const {
    reaservationStatus,
    carDetails,
    startDate,
    endDate,
    location,
    fleet,
    cost,
    id,
    reservationStatusId
  } = ride
  const projectId = fleet === "A2A" ? 1 : 5
  const dispatch = useAppDispatch()
  const { i18n, t } = useTranslation()
  const formatDate = (dateStr: any) => {
    moment.locale(i18n.language)
    return moment(dateStr).format("dddd, DD.MM.YYYY, HH:mm")
  }
  return (
    <ListItem className="ride-item flex center" divider>
      {fleet === "A2A" ? <A2A /> : <A2B />}
      <div className="ride-info">
        <Typography className="location" variant="h5">
          {location?.fullAddressStart}
        </Typography>
        <ListItemText
          primary={carDetails?.nickname}
          secondary={`${formatDate(startDate)} | ${formatDate(endDate)}`}
          className="ride-text"
        />
        {reservationStatusId === 5 && <span className="status">{t("my_rides_cancelled")}</span>}
        {reservationStatusId !== 5 && cost !== null && cost >= 0 && (
          <span className="cost">{cost} ₪</span>
        )}
        {reservationStatusId === 0 &&<Button onClick={() => dispatch(cancelReservationAsync({ reservationId: id, projectId: projectId }))}>
          {t("cancel")}
        </Button>}
      </div>
    </ListItem>
  )
}
